import React, { useContext, createContext, useState, type JSX } from 'react';
import { type SelectListItem } from '@resources/js/typings/viewModels/selectListItemViewModel';

type BuildsRotationFacetsContext = {
  facet: SelectListItem<string> | undefined;
  setFacet: (facet: SelectListItem<string> | undefined) => void;
  facetOptions: SelectListItem<string>[];
  setFacetOptions: (facetOptions: SelectListItem<string>[]) => void;
};

const defaultBuildsRotationFacetsContext: BuildsRotationFacetsContext = {
  facet: undefined,
  setFacet: () => {},
  facetOptions: [],
  setFacetOptions: () => {},
};

export const BuildsRotationFacetsContext =
  createContext<BuildsRotationFacetsContext>(
    defaultBuildsRotationFacetsContext,
  );

const useBuildsRotationFacets = (): BuildsRotationFacetsContext =>
  useContext(BuildsRotationFacetsContext);

export const BuildsRotationFacetsContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => {
  const [facet, setFacet] = useState<SelectListItem<string>>();
  const [facetOptions, setFacetOptions] = useState<SelectListItem<string>[]>(
    [],
  );

  const value = {
    facet,
    setFacet,
    facetOptions,
    setFacetOptions,
  };

  return (
    <BuildsRotationFacetsContext.Provider value={value}>
      {children}
    </BuildsRotationFacetsContext.Provider>
  );
};

export default useBuildsRotationFacets;
